
import { Button } from 'antd'
import { useState } from 'react'
import { PlusOutlined } from '@ant-design/icons';

import DocumentGuidesDetails from "./DocumentGuidesDetails";
import DocumentGuideList from "./DocumentGuideList";

const DocumentGuideView = () => {
    const [visible, setVisible] = useState(false);
    const [modalType, setModalType] = useState("Add New User Guide");

    const showModal = (record, type) => { 
        setVisible(record);
        setModalType(type);
    };

    return (
        <>
            <div className="content">
                <Button
                    className="add-button"
                    key="add-button-1"
                    type="primary"
                    onClick={() => showModal({}, "add")}
                    icon={<PlusOutlined />}
                >
                    {""} Add New
                </Button>
                <br /> <br />
                <DocumentGuidesDetails
                    key={"a2"}
                    type={modalType}
                    setType={setModalType}
                    record={visible}
                    onShow={showModal}
                />
                <DocumentGuideList
                    key={"guide-list"}
                    modalType={modalType}
                    setModalType={setModalType}
                    showModal={showModal}
                />
            </div>
        </>
    )
}

export default DocumentGuideView;